var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6V17C7 18.1046 7.89543 19 9 19H15C16.1046 19 17 18.1046 17 17V6H7ZM19 17C19 19.2091 17.2091 21 15 21H9C6.79086 21 5 19.2091 5 17V6H3.5C3.22386 6 3 5.77614 3 5.5V4.5C3 4.22386 3.22386 4 3.5 4H9V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H20.5C20.7761 4 21 4.22386 21 4.5V5.5C21 5.77614 20.7761 6 20.5 6H19V17Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 17C9.22386 17 9 16.7761 9 16.5V9.5C9 9.22386 9.22386 9 9.5 9H10.5C10.7761 9 11 9.22386 11 9.5V16.5C11 16.7761 10.7761 17 10.5 17H9.5Z",
    fill: "#71869D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 17C13.2239 17 13 16.7761 13 16.5V9.5C13 9.22386 13.2239 9 13.5 9H14.5C14.7761 9 15 9.22386 15 9.5V16.5C15 16.7761 14.7761 17 14.5 17H13.5Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteGray);
export default __webpack_public_path__ + "static/media/iconDeleteGray.a619c106054fd5eb6fa0cee0aae81c0d.svg";
export { ForwardRef as ReactComponent };